export default "__VITE_ASSET__CVIeLiZV__"